import clsx from "clsx";
import { ChevronUp, ChevronDown } from "lucide-react";

export const SortStateIcons = (sort: "asc" | "desc" | null) => {
  return (
    <div className="flex flex-col -space-y-1">
      <ChevronUp
        className={clsx(
          sort === "asc" ? "text-blue-600" : "text-gray-400 group-hover:text-gray-600",
        )}
        width={16}
        height={16}
        strokeWidth={sort === "asc" ? 3 : 1}
      />
      <ChevronDown
        className={clsx(
          sort === "desc" ? "text-blue-600" : "text-gray-400 group-hover:text-gray-600",
        )}
        width={16}
        height={16}
        strokeWidth={sort === "desc" ? 3 : 1}
      />
    </div>
  );
};
